module.exports = __webpack_public_path__ + "static/media/everyday_digital_weekend_papers_footy2024.57e4f866.png";